import { makeSavedObject } from "../../create/saveObjects";
import { incrementGeneralArray } from "../../firebase/fireFuncs";

function saveGoal(
  getPluralType,
  boxType,
  generalObject,
  playerUid,
  onIncremented
) {
  incrementGeneralArray(
    getPluralType,
    generalObject,
    "saved",
    "player",
    playerUid,
    () => {
      const savedObject = makeSavedObject(generalObject, boxType);

      onIncremented(savedObject);
    }
  );
}

export { saveGoal };
